import { Text } from '@chakra-ui/core'
import React from 'react'

interface Props {
  label: string
  isRequired?: boolean
}
export const FormInputLabel: React.FC<Props> = ({ label, isRequired }) => {
  return (
    <Text pb="5px" px="10px" fontSize="12px">
      {label}
      {isRequired && (
        <Text as="span" color="#FC8181" ml="4px">
          *
        </Text>
      )}
    </Text>
  )
}
